import React from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import { ListItem, Tooltip } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { AI_CONVERSATION_TYPE } from 'utils/enum/OpenAIEnum';
import StringUtils from 'lib/StringUtils';
import DateUtils from 'lib/DateUtils';
import PhoneUtils from 'lib/PhoneUtils';
import CallOutlinedIcon from '@material-ui/icons/CallOutlined';
import LanguageOutlinedIcon from '@material-ui/icons/LanguageOutlined';

const useStyles = makeStyles((theme) => ({
    bodyConversation: {
        display: 'flex',
        width: '100%',
    },
    listItem: {
        backgroundColor: theme.palette.background.secondary,
        marginBottom: theme.spacing(3),
        borderRadius: theme.spacing(1),
        padding: theme.spacing(3, 1.5),
        '&:last-child': {
            marginBottom: 0,
        },
        flexDirection: 'column',
        border: '2px solid transparent',
        cursor: 'pointer',
    },
    container: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        paddingLeft: 20,
    },
    phoneContainer: {
        display: 'flex',
        alignItems: 'center',
        fontSize: 18,
        fontWeight: 'bold',
    },
    phoneIcon: {
        marginRight: 10,
    },
    ipContainer: {
        display: 'flex',
        alignItems: 'center',
        fontSize: 18,
        fontWeight: 'bold',
    },
    ipIcon: {
        marginRight: 10,
    },
    detailsContainer: {
        display: 'flex',
        fontSize: 13,
        justifyContent: 'space-between',
        marginTop: 10,
    },
    recorded: {
        color: theme.palette.text.green,
        fontWeight: 'bold',
    },
    conversationSelected: {
        border: `2px solid rgb(${theme.palette.rgb.purple}, 0.5)`,
    },
}));

const AIConversationHeader = ({
    type,
    record,
    selectedConversationId,
    setSelectedConversation,
}) => {
    const classes = useStyles();
    const selectedClass = selectedConversationId === record.id ? classes.conversationSelected : '';

    const {
        from,
        ip,
        recordingURL,
        createdOn,
    } = record;

    return (
        <ListItem
            className={clsx(classes.listItem, selectedClass)}
            onClick={() => setSelectedConversation(record)}
        >
            <div className={classes.bodyConversation}>
                <div className={classes.container}>
                    {type === AI_CONVERSATION_TYPE.CALL && (
                        <div className={classes.phoneContainer}>
                            <CallOutlinedIcon className={classes.phoneIcon} />
                            <span>{PhoneUtils.formatPhone(from)}</span>
                        </div>
                    )}
                    {type === AI_CONVERSATION_TYPE.WEB_CHAT && (
                        <div className={classes.ipContainer}>
                            <LanguageOutlinedIcon className={classes.ipIcon} />
                            <span>{ip}</span>
                        </div>
                    )}
                    <div className={classes.detailsContainer}>
                        <div>
                            <Tooltip title={DateUtils.getFormattedDateInUserTimezone(createdOn)} placement="top">
                                <span>{DateUtils.fromNow(createdOn)}</span>
                            </Tooltip>
                        </div>
                        <div className={classes.recorded}>
                            {!StringUtils.isEmpty(recordingURL) ? 'Recorded' : ''}
                        </div>
                    </div>
                </div>
            </div>
        </ListItem>
    );
};

AIConversationHeader.propTypes = {
    type: PropTypes.string.isRequired,
    record: PropTypes.object.isRequired,
    selectedConversationId: PropTypes.string,
    setSelectedConversation: PropTypes.func.isRequired,
};

AIConversationHeader.defaultProps = {
    selectedConversationId: null,
};

export default AIConversationHeader;
